module.exports = __webpack_public_path__ + "img/template.9ad03df8.svg";